import React from "react";
import { MediaImage } from "../../types";
import {
  HeaderContainer,
  HeaderWrapper,
  HeaderLogoContainerStyle,
  HeaderTitleContainerStyle,
  HeaderLanguageSelectorContainer,
  HeaderRightContainer,
  HeaderLeftContainer,
} from "./Header.style";
import Title from "../Title/Title.component";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import { SUPPORTED_LANGUAGE } from "../../content";

interface Props {
  logo: MediaImage;
  title: string;
  autoWidth: number;
  hidden?: boolean;
}

const Header: React.FC<Props> = (props) => {
  return (
    <HeaderContainer hidden={props.hidden}>
      <HeaderWrapper className="header-wrapper">
        <HeaderLeftContainer>
          <HeaderLogoContainerStyle className="header-logo-container" href="#">
            <img src={props.logo.url} alt={props.logo.alt} />
          </HeaderLogoContainerStyle>
        </HeaderLeftContainer>
        <HeaderRightContainer className="header-right-container">
          <HeaderLanguageSelectorContainer className="mobile header-language-selector-container">
            {SUPPORTED_LANGUAGE.length > 1 && <LanguageSelector languageList={[...SUPPORTED_LANGUAGE]} />}
          </HeaderLanguageSelectorContainer>
          <HeaderTitleContainerStyle autoWidth={props.autoWidth} className="header-title-container">
            <Title level={1}>
              <div dangerouslySetInnerHTML={{ __html: props.title }} />
            </Title>
          </HeaderTitleContainerStyle>
        </HeaderRightContainer>
      </HeaderWrapper>
      <HeaderLanguageSelectorContainer className="header-language-selector-container">
        {SUPPORTED_LANGUAGE.length > 1 && <LanguageSelector languageList={[...SUPPORTED_LANGUAGE]} />}
      </HeaderLanguageSelectorContainer>
    </HeaderContainer>
  );
};

export default Header;
